/**
 * @param {Array<{ code?: string }>} parentTypes
 */
export function findCellParentType(parentTypes) {
  if (!Array.isArray(parentTypes)) {
    return null;
  }
  return parentTypes.find(type => type.code === 'CELL') || null;
}

/**
 * 서버·HAL에 결함 유형이 이미 지정됐는지 (id 또는 parent 참조).
 * @param {unknown} defect
 */
export function hasDefectCode(defect) {
  const code = defect?.defectCode ?? defect?._embedded?.defectCode;
  if (code == null || typeof code !== 'object') {
    return false;
  }
  if (code.id != null && code.id !== '') {
    return true;
  }
  if (code.parent != null) {
    return true;
  }
  return false;
}

/** defectCode 없음 → 상위 CELL 초기값 */
export function shouldUseCellDefaultForDefect(defect) {
  return !hasDefectCode(defect);
}

/**
 * defectCode HAL 객체가 상위/하위 중 어디에 해당하는지 판별.
 */
export function getDefectCodeType(defectCode) {
  if (defectCode && defectCode.parent) {
    return 'detail';
  }
  if (defectCode) {
    return 'main';
  }
  return 'unknown';
}
